<template>
	<div>
		<v-dialog v-model="showDialog" max-width="400" persistent>
			<v-card>
				<v-card-title> Add Template Fields from file </v-card-title>
				<v-card-text>
					<v-row no-gutters>
						<v-file-input
							class="mr-4"
							v-model="file"
							counterlabel="File input"
							placeholder="Select a file"
							prepend-icon="mdi-paperclip"
							dense
							accept=".xlsx,.csv"
							show-size
						/>
					</v-row>
				</v-card-text>
				<v-divider />
				<v-card-actions>
					<v-btn @click.stop="onClose">Close</v-btn>
					<v-spacer />
					<v-btn color="primary" @click.stop="onSave">Upload</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
import { TemplateActions } from '../../../store/actions';

export default {
	name: 'FileUploadModal',
	props: {
		showDialog: Boolean,
		selectedTemplate: Object,
	},
	data() {
		return {
			file: null,
		};
	},
	methods: {
		onSave() {
			let item = {
				file: this.file,
				importFile: { GridViewId: this.selectedTemplate.Id },
			};
			this.$store
				.dispatch(TemplateActions.UPLOAD_TEMPLATE_FIELDS, item)
				.then(() => {
					this.$emit('close');
				});
		},

		onClose() {
			this.$emit('close');
		},
	},
};
</script>
